import { Splide } from '@splidejs/splide';

Splide.defaults = {
  resetProgress: true,
  perPage: 1,
  arrowPath: 'M10 1L30 21L10 41',
  video: {
    autoplay: true,
    loop: true,
    mute: true,
    disableOverlayUI: true,
    hideControls: true,
  },
};

export default Splide;
